import { render } from "./leads.vue?vue&type=template&id=0d24d57a&scoped=true"
import script from "./leads.vue?vue&type=script&lang=js"
export * from "./leads.vue?vue&type=script&lang=js"

import "./leads.vue?vue&type=style&index=0&id=0d24d57a&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d24d57a"]])

export default __exports__